export const LOCAL_STORAGE_KEYS = {
  SELECTED_REGION: 'selectedRegion',
} as const;

export const REGION_NAMES = {
  SED_BALOCHISTAN: 'sed_balochistan',
  FREE_TIER: 'free_tier',
} as const;
export const tempLSPhoneKey = 'tempLSPhoneKey';
export const tempUserName = 'tempUserName';
export const hasVisitedSignIn = 'hasVisitedSignIn';
